package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun PageMainContent(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<PageMainContentKind>? = null,
    content: @Composable () -> Unit,
) {
    Box(
        modifier = PageContentStyle.toModifier(variant).then(modifier),
    ) {
        content()
    }
}

sealed interface PageMainContentKind : ComponentKind

val PageContentStyle = CssStyle<PageMainContentKind> {
    base {
        Modifier
            .fillMaxWidth()
            .minHeight(Dimens.spacingNone)
            .padding(leftRight = Dimens.pageMainContentIntent, topBottom = Dimens.pageMainContentWrapping)
    }
}

val PageContentNoIndentVariant = PageContentStyle.addVariant {
    base {
        Modifier
            .padding(Dimens.spacingNone)
    }
}
